import {PaymentCurrencyType} from "@irati/payments/enums/PaymentV2"
import {StatementItemInfo, StatementItem} from "@irati/types"
import {formatCurrency} from "@irati/utils/currency/formatCurrency"
import {useIntl} from "@irati/utils/lang"
import isContentKey from "@irati/utils/lang/helpers/isContentKey"

/**
 * Parse a statementItem (expected to be of type BE_SIMPLE_STATEMENT) into primary and secondary details for display
 * in a StatementRow component
 */
export function useStatementItemDetails(statementItem: StatementItem) {
  const {currency, amount} = statementItem.transfer || {}

  const primaryDetails = {
    title: useFormattedMsg(statementItem.content?.title, currency),
    subTitle: useFormattedMsg(statementItem.content?.subTitle, currency),
    amount,
    currency,
    status: statementItem.content?.status
  }

  const secondaryDetails = useFormattedMsg(statementItem.content?.details, currency)
  return {
    primaryDetails,
    secondaryDetails
  }
}

function useFormattedMsg(info?: StatementItemInfo, currency?: string) {
  const {formatNumber, formatMessage} = useIntl()
  if (!info) return null

  const {text, values, currencyKeys, numberKeys} = info

  if (!isContentKey(text)) return text

  const valueObject = Object.fromEntries(values || [])

  numberKeys?.forEach((key) => {
    if (valueObject[key]) {
      valueObject[key] = formatNumber(valueObject[key])
    }
  })

  currencyKeys?.forEach((key) => {
    if (valueObject[key]) {
      valueObject[key] = formatCurrency({isCents: currency !== PaymentCurrencyType.Tt, currencyCode: currency, value: valueObject[key]})
    }
  })

  return formatMessage({id: text}, valueObject)
}
